import { InjectionToken } from "@angular/core";
import { IApplicationsOverviewModalService } from "./i-applications-overview-modal.service";

export const applicationsOverviewModalServiceInjectionToken: InjectionToken<IApplicationsOverviewModalService> = new InjectionToken<IApplicationsOverviewModalService>("digital-signage.user-dashboard.dashboard-web.AvailableAppsOverviewModalService");
